/**
 * A sheet that knows which device it's on.
 *
 * Every "write something about this" surface in the app used the same hand-
 * rolled geometry: a fixed scrim, align-items flex-end, rounded top corners.
 * That's correct on a phone and wrong on a laptop, where the panel hangs off
 * the bottom of the window and the grab bar at the top implies a drag that
 * doesn't exist. Above 700px this becomes a centred dialog instead.
 *
 * The geometry lives in dashboard.css so it's one set of rules rather than
 * one per call site; this component only supplies the surface colours and
 * the close behaviour.
 */
import React, { useEffect } from "react";
import SheetHandle from "./SheetHandle";

function Sheet({ C, onClose, label, maxWidth = 540, children }) {
  // Escape closes, the way every other dialog in the app does.
  useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);

  return (
    <div className="bam-sheet-scrim" onClick={onClose}>
      <div className="bam-sheet" role="dialog" aria-modal="true" aria-label={label}
        onClick={e => e.stopPropagation()}
        style={{ maxWidth, background: C.bg, border: `1px solid ${C.border}` }}>
        <div className="bam-sheet-grab"><SheetHandle/></div>
        {children}
      </div>
    </div>
  );
}

export default Sheet;
